import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './help-header-button.scss';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

applyTranslations(require('./help-header-button.i18n.json'));

type Props = {
  hasVideos: boolean,
  hasUnwatchedVideos: boolean,
  onClick?: () => void
};

const HelpHeaderButton = (
  {
    onClick,
    hasVideos,
    hasUnwatchedVideos
  }: Props
): JSX.Element => (
  <div className="help-header-button" onClick={onClick}>
    {hasVideos && (
      <span className="help-header-button__video-icon">
        <SVGDynamicIcon
          name={hasUnwatchedVideos ? 'play-button-custom-bg' : 'play-button-custom-fg'}
          width={16}
          height={16}
          customColor={hasUnwatchedVideos ? 'blue' : 'white'}
        />
      </span>
    )}
    {__t('help_header_button.title')}
  </div>
);

export default HelpHeaderButton;
